// Non-Deriv chart constants: timeframes, chart types, indicators, drawing tools.
// Components that previously imported these from symbols.ts import from here instead.

export { DRAWING_TOOLS, TOOL_LABELS, DRAWING_TOOL_IDS, DRAWING_TOOL_GROUPS } from './drawingToolDefinitions';
export type { DrawingToolId, DrawingToolDefinition, DrawingToolGroup } from './drawingToolDefinitions';

export const TIMEFRAMES = ['1m', '5m', '15m', '30m', '1h', '2h', '4h', '8h', '1d', '1w', '1Mn'] as const;
export type Timeframe = typeof TIMEFRAMES[number];

export const CHART_TYPES = [
  { value: 'candle_solid',       label: 'Candlestick',    shortLabel: 'Candles' },
  { value: 'candle_stroke',      label: 'Hollow Candle',  shortLabel: 'Hollow'  },
  { value: 'candle_heikin_ashi', label: 'Heikin Ashi',    shortLabel: 'HA'      },
  { value: 'area',               label: 'Area',           shortLabel: 'Area'    },
  { value: 'line',               label: 'Line',           shortLabel: 'Line'    },
  { value: 'ohlc',               label: 'OHLC Bars',      shortLabel: 'OHLC'    },
] as const;

export type ChartTypeValue = typeof CHART_TYPES[number]['value'];

export type IndicatorCategory = 'trend' | 'momentum' | 'volatility';

export interface IndicatorDefinition {
  id: string;
  label: string;
  description: string;
  category: IndicatorCategory;
}

export const INDICATORS: IndicatorDefinition[] = [
  // Trend
  { id: 'MA',           label: 'Moving Average',   description: 'Smooth price data to identify trends',                           category: 'trend'      },
  { id: 'SMA',          label: 'SMA',              description: 'Simple moving average for baseline trend direction',              category: 'trend'      },
  { id: 'EMA',          label: 'EMA',              description: 'Faster moving average that weights recent price action',         category: 'trend'      },
  { id: 'SAR',          label: 'Parabolic SAR',    description: 'Trend reversal dots',                                           category: 'trend'      },
  // Momentum
  { id: 'RSI',          label: 'RSI',              description: 'Relative Strength Index for overbought and oversold structure',  category: 'momentum'   },
  { id: 'MACD',         label: 'MACD',             description: 'Trend momentum with fast and slow moving averages',              category: 'momentum'   },
  { id: 'KDJ',          label: 'KDJ',              description: 'Stochastic-style oscillator tuned for swing momentum',          category: 'momentum'   },
  { id: 'LYTICK_STOCH', label: 'Stochastic',       description: 'Momentum oscillator with %K and %D',                           category: 'momentum'   },
  { id: 'CCI',          label: 'CCI',              description: 'Commodity Channel Index for mean-reversion extremes',           category: 'momentum'   },
  { id: 'WR',           label: 'Williams %R',      description: 'Range-based momentum oscillator for entry timing',              category: 'momentum'   },
  // Volatility
  { id: 'BOLL',         label: 'Bollinger Bands',  description: 'Dynamic volatility bands around moving average price',          category: 'volatility' },
  { id: 'LYTICK_ATR',   label: 'ATR',              description: 'Average True Range volatility measure',                        category: 'volatility' },
];
